import { Icon } from '@kurtosys/ksys-app-components/dist/components/base/Icon/Icon';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Icon, 'passwordValidation', ['ruleIcon']);